export const etatPanierItemProps = () => ({
  article: {
    type: Object,
    required: true
  },
  showSimilaires: {
    type: Boolean,
    required: false,
    default: false
  },
  showQuantiteInsuffisante: {
    type: Boolean,
    required: false,
    default: false
  }
})
